import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import Fruit from '../components/Fruit'
import Main from '../components/Main'
import News from '../components/News'
import NewsInfo from '../components/NewsInfo'
import Product from '../components/Product'
import Infos from '../components/Infos'
import Fashion from '../components/Fashion'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/fruit',
            name: 'Fruit',
            component: Fruit
        },
        {
            path: '/fashion',
            name: 'Fashion',
            component: Fashion
        },
        {
            path: '/main',
            name: 'Main',
            component: Main
        },
        {
            path: '/news',
            name: 'News',
            component: News
        },
        {
            path: '/newsInfo',
            name: 'NewsInfo',
            component: NewsInfo
        },
        {
            path: '/product',
            name: 'Product',
            component: Product
        },
        {
            path: '/Infos',
            name: 'Infos',
            component: Infos
        },
    ]
})
